import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Reset Mental: El Mapa de tu Dinero',
    desc: 'El punto de partida del sistema. Antes de ordenar la plata, hay que ordenar la cabeza.',
    bullets: ['Diagnóstico financiero completo', 'Cómo detectar gastos hormiga', 'Contrato financiero personal', 'Mentalidad para avanzar', 'Checklist de inicio', 'Plan de acción semana 1']
  }, {
    icon: '📗',
    title: 'Blindaje Criollo: Tu Plata en la Argentina Real',
    desc: 'El sistema financiero argentino explicado para mortales.',
    bullets: ['Mapa del sistema financiero argentino', 'Presupuesto anti-inflación en 5 bloques', 'Protocolo de crisis', 'Blindaje contra estafas digitales', 'Checklist mensual', 'Plantillas listas']
  }, {
    icon: '📙',
    title: 'El Poder de la Deuda Inteligente',
    desc: 'No toda deuda es mala. Aprenderás a distinguir la que destruye de la que construye.',
    bullets: ['Deuda buena vs deuda peligrosa', 'Cómo negociar con bancos', 'Tarjeta como herramienta', 'Estrategia para saldar deudas', 'Seguridad digital', 'Checklist de blindaje']
  }, {
    icon: '📕',
    title: 'Tus Primeras Inversiones Sin Miedo',
    desc: 'El manual para empezar a invertir en Argentina sin ser economista.',
    bullets: ['5 instrumentos accesibles', 'Tu primer CEDEAR paso a paso', 'Dólar MEP legal', 'Cómo elegir broker', 'Estrategia DCA', 'Checklist primera inversión']
  }, {
    icon: '📓',
    title: 'Ingresos Extra y Libertad Laboral',
    desc: 'Monotributo 2026, negocios rentables, freelance y estrategias para Argentina.',
    bullets: ['Negocios rentables 2026', 'Monotributo sin morir', '5 fuentes de ingreso extra', 'Cobrar en dólares legal', 'De empleado a dueño', 'Checklist de inicio']
  }, {
    icon: '📔',
    title: 'La Ruta del Oro 2026',
    desc: 'Tu centro de mando financiero. Plan de 90 días.',
    bullets: ['Método 30-90-180', 'Portafolio personal', 'Revisión semanal de 15 min', 'Rutina mensual', 'Hoja de ruta 12 meses', 'Manifiesto del inversor']
  }];
  const features = ['Contenido listo para aplicar (sin teoría vacía)', 'Lenguaje directo, sin jerga económica complicada', 'Adaptado al contexto argentino real de 2026', 'Fichas, plantillas y checklists imprimibles', 'Ejemplos con números reales de Argentina', '100% orientado a resultados concretos y medibles'];
  return <section className="bg-cream py-16 px-4" data-id="element-219">
      <div className="max-w-6xl mx-auto" data-id="element-220">
        <div className="text-center mb-12" data-id="element-221">
          <h2 className="text-3xl md:text-5xl font-bold text-ink mb-4 font-serif" data-id="element-222">
            🏆 DOMINIO FINANCIERO™
          </h2>
          <p className="text-lg md:text-2xl text-primary font-bold mb-2 tracking-wide" data-id="element-223">
            6 Tomos + 6 Bonos — 300+ páginas
          </p>
          <p className="text-base md:text-xl text-muted font-medium" data-id="element-224">
            El sistema completo para ordenar, proteger y multiplicar tu dinero
            en la Argentina real.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-225">
          {tomos.map((tomo, idx) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} key={idx} className="bg-white rounded-2xl p-8 border border-border shadow-sm hover:shadow-md transition-shadow" data-id="element-226">
              <div className="flex items-start mb-4" data-id="element-227">
                <span className="text-4xl mr-4" data-id="element-228">{tomo.icon}</span>
                <div data-id="element-229">
                  <h4 className="text-xl font-bold text-ink font-serif leading-tight" data-id="element-230">
                    {tomo.title}
                  </h4>
                </div>
              </div>
              <p className="text-muted mb-6 text-sm md:text-base font-medium" data-id="element-231">
                {tomo.desc}
              </p>
              <div className="bg-surface rounded-xl p-5 border border-border/50" data-id="element-232">
                <ul className="space-y-3" data-id="element-233">
                  {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start text-sm text-ink font-medium" data-id="element-234">
                      <CheckCircle2 className="w-5 h-5 text-success mr-3 shrink-0" data-id="element-235" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary-dark rounded-2xl p-8 md:p-12 border border-gold/30 shadow-lg" data-id="element-236">
          <h4 className="text-2xl md:text-3xl font-bold text-cream mb-8 text-center font-serif" data-id="element-237">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-238">
            {features.map((feature, i) => <div key={i} className="flex items-center text-cream bg-black/20 p-4 rounded-lg border border-white/10" data-id="element-239">
                <span className="text-gold mr-4 text-xl" data-id="element-240">✅</span>
                <span className="text-sm md:text-base font-medium" data-id="element-241">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}